export enum RoomLayout {
  SingleContent = 'single content',
  Story2Columns = 'story 2 columns',
  Story3Columns = 'story 3 columns',
  Tiles = 'tiles', // 2 columns
  Tiles3Columns = 'tiles 3 columns',
}

export enum RoomContentMode {
  Default = 'default',
  Tile = 'tile',
}

export enum RoomSectionHeadersMode {
  Default = 'default',
  MenuList = 'menu-list',
  Tabs = 'tabs',
}

export const getContentModeFromLayout = (layout?: RoomLayout) =>
  isTilesLayout(layout) ? RoomContentMode.Tile : RoomContentMode.Default;

export const getSectionHeadersModeFromLayout = (layout?: RoomLayout) =>
  layout === RoomLayout.Story3Columns || layout === RoomLayout.Tiles3Columns
    ? RoomSectionHeadersMode.Default
    : RoomSectionHeadersMode.Tabs;

export const isTilesLayout = (layout?: RoomLayout): boolean =>
  layout === RoomLayout.Tiles || layout === RoomLayout.Tiles3Columns;

export const ROOM_LAYOUT_NAME_KEY: Record<RoomLayout, string> = {
  [RoomLayout.SingleContent]: '',
  [RoomLayout.Story2Columns]: 'room.settings.layout.story_2_columns',
  [RoomLayout.Story3Columns]: 'room.settings.layout.story_3_columns',
  [RoomLayout.Tiles]: 'room.settings.layout.tiles', // 2 columns
  [RoomLayout.Tiles3Columns]: 'room.settings.layout.tiles_3_columns',
};
